<template>
  <div class="modal fade" id="rollOutPromotionModal" tabindex="-1" role="dialog" aria-labelledby="rollOutPromotionModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="rollOutPromotionModalLabel">Add Roll Out Promotions</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="custom-label">Promotion</label>
            <br>
            <input v-model="name" class="form-control">
          </div>
          <div class="form-group">
            <label class="custom-label">Date</label>
            <br>
            <datepicker
              format="dd.MM.yyyy"
              v-model="date"
              :bootstrap-styling="true"
              input-class="bg-white"
            />
          </div>
          <div class="form-group">
            <label class="custom-label">Description</label>
            <br>
            <textarea class="form-control" rows="5" v-model="description"></textarea>
          </div>
        </div>
        <div class="modal-footer" style="justify-content: space-between;">
          <button type="button" class="btn btn-primary" @click="addPromotion">Add</button>
          <button type="button" class="btn btn-warning" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    props: ['rollOutId', 'post'],
    data() {
      return {
        name: '',
        date: new Date(),
        description: '',
      }
    },
    methods: {
      addPromotion() {
        const promo = {
          id: null,
          name: this.name,
          date: this.date ? moment(this.date).format('YYYY-MM-DD') : '',
          description: this.description,
        }

        if (this.post) {
          window.axios.post(`/roll_outs/${this.rollOutId}/roll_out_promotions`, promo).then(({data}) => {
            this.commitPromo(data)
          })
        } else {
          this.commitPromo(promo)
        }
      },
      commitPromo(promo) {
        this.$store.commit('addRollOutPromotion', promo)
        $('#rollOutPromotionModal').modal('hide')
      },
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/RollOutPromotionModal.vue